<template>
  <div class="fiance-address-bd tb">
    <div class="search-hd">
      <el-form :inline="true" @submit.native.prevent>
        <el-form-item v-if="funcView.address_add">
          <el-button type="primary" icon="el-icon-plus" @click="addAddress()">{{ $t('crm_financeAddress.xzshdz') }}</el-button>
        </el-form-item>
        <!-- 搜索项 -->
        <el-form-item style="float: right">
          <el-input :placeholder="$t('crm_financeAddress.lxrshdz')" v-model="formSearch.search" clearable @keyup.enter.native="onPageChange({ page: 1 })" style="width: 280px">
            <template slot="append">
              <div @click="onPageChange({ page: 1 })">
                <i class="icon icon-search"></i>
              </div>
            </template>
          </el-input>
        </el-form-item>
      </el-form>
    </div>
    <div class="table-bd">
      <custom-table height="100%" :data="addressList" :column="tableColumn" @filter="filterChange" @sort="sortChange" :slots="['shippingAddress']">
        <template v-slot:shippingAddress="scope">
          <span>{{ scope.row.country }}{{ scope.row.province }}{{ scope.row.city }}{{ scope.row.detailAddress }}</span>
        </template>
        <el-table-column :label="$t('Common.com_handle')" fixed="right" min-width="120" v-if="tableColumn.length">
          <template slot-scope="scope">
            <span></span>
            <el-button type="text" size="mini" v-if="funcView.address_delete" @click="deleteAddress(scope.row)">
              {{ funcView.address_delete }}
            </el-button>
            <el-button type="text" size="mini" v-if="funcView.address_edit" @click="editAddress(scope.row)">
              {{ funcView.address_edit }}
            </el-button>
            <el-button type="text" size="mini" v-if="scope.row.isDefault" style="color: red">{{ $t('crm_financeAddress.mo_ren_di_zhi') }}</el-button>
            <el-button type="text" size="mini" v-if="!scope.row.isDefault && funcView.address_set_default" @click="defaultAddress(scope.row)">{{ funcView.address_set_default }}</el-button>
          </template>
        </el-table-column>
      </custom-table>
    </div>
    <div class="table-page">
      <custom-page :total="totalRows" :page="formSearch.pageNum" :size="formSearch.pageSize" @change="onPageChange"></custom-page>
    </div>
    <!--收货地址-->
    <finance-address-dialog v-if="dialogVisible" :model="dialogModel" @close="dialogVisible = false" @success="getAddressList"></finance-address-dialog>
  </div>
</template>

<script>
import apis from '@/utils/apis';
import financeAddressDialog from './children/finance_address_dialog.vue';

export default {
  name: 'financeAddress',
  components: { financeAddressDialog },
  data() {
    return {
      tableCode: 'financeAddress_list',
      formSearch: {
        search: '',
        orderType: '',
        orderBy: '',
        pageSize: 50,
        pageNum: 1,
      },
      totalRows: null,
      addressList: [],
      cascaderProps: {
        value: 'code',
        label: 'value',
      },
      addressForm: {
        consigneeName: '',
        consigneePhone: '',
        address: '', // 自用不参与交互
        detailAddress: '', // 详细地址
        deliverAddressId: '', // 地址ID
        // 地址
        country: '',
        countryCode: '',
        province: '',
        provinceCode: '',
        city: '',
        cityCode: '',
      },

      // 编辑地址
      dialogVisible: false,
      dialogModel: {},
    };
  },
  computed: {
    rules() {
      return {
        // 基本信息
        consigneeName: [{ required: true, message: this.$t('Common.com_required') }, { max: 20 }], //
        consigneePhone: [{ required: true, message: this.$t('Common.com_required') }, { max: 20 }], // 应用场景
        address: { required: true, message: this.$t('Common.com_required') }, // 自用不参与交互
        detailAddress: [{ required: true, message: this.$t('Common.com_required') }, { max: 100 }],
      };
    },
    label_shipping_address() {
      return this.$t('crm_financeAddress.shou_huo_di_zhi');
    },
  },
  mounted() {
    this.getTableColumn();
    this.getAddressList();
    this.getFuncView();
  },
  methods: {
    // 获取地址
    getAddressList: function () {
      this.$getJSON(apis.partnerDeliverAddress, this.formSearch).then((res) => {
        this.addressList = res.data.list;
        this.totalRows = res.data.total;
      });
    },
    // 切换页
    onPageChange: function ({ page, size }) {
      this.formSearch.pageNum = page;
      this.formSearch.pageSize = size || this.formSearch.pageSize;
      this.getAddressList();
    },
    // 新增地址
    addAddress: function () {
      this.dialogModel.title = this.$t('crm_financeAddress.xzshdz');
      this.dialogModel.type = 'add';
      this.dialogVisible = true;
    },
    // 编辑地址
    editAddress: function (item) {
      this.dialogModel.title = this.$t('crm_financeAddress.bjshdz');
      this.dialogModel.type = 'edit';
      this.dialogModel.data = {
        item,
        id: item.deliverAddressId,
      };
      this.dialogVisible = true;
    },
    // 删除地址
    deleteAddress: function ({ deliverAddressId }) {
      this.$showConfirm(this.$t('crm_financeAddress.nqdyscxzddzm'))
        .then(() => {
          this.$deleteJSON(`${apis.partnerDeliverAddressDelete}/${deliverAddressId}`).then((res) => {
            if (res.code === 0) {
              this.$message({
                message: this.$t('Common.com_delete_success'),
                type: 'success',
              });
              this.getAddressList();
            }
          });
        })
        .catch(() => {});
    },
    // 设为默认
    defaultAddress: function ({ deliverAddressId }) {
      this.$postJSON(`${apis.partnerDeliverAddressDefualt}/${deliverAddressId}`).then((res) => {
        if (res.code === 0) {
          this.$message({
            message: this.$t('Common.com_handle_success'),
            type: 'success',
          });
          this.getAddressList();
        }
      });
    },
  },
};
</script>

<style lang="scss"></style>
